import React from "react";
import {
  View,
  StyleSheet,
  SafeAreaView,
  ActivityIndicator,
  ImageBackground,
  Image,
  Dimensions
} from "react-native";
import { Surface } from "react-native-paper";
import Timer from "./timer";
import Quiz from "./index2";
import { connect } from "react-redux";
import {
  getTest,
  // dispatchClearHomeInfo,
  clearTest,
  clearSubmitTestData,
  submitTest,
} from "../../store/action";
// import BackHandlerAndroid from './../AndroidBackHandler';
// import {resetAll} from './../../navigators/navigationService';
// import Toast, {DURATION} from 'react-native-easy-toast'
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import StylesColors from './../Colors';
// import Icon from 'react-native-vector-icons/dist/Ionicons';
// import Icons from 'react-native-vector-icons/dist/FontAwesome';
// const isIos = Platform.OS === "ios";
// import OfflineHandler from './../OfflineHandler';
import { Text, Styles } from "./../../components/UI-Components";
import Icon from "@material-ui/core/Icon";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import Container from "@material-ui/core/Container";
import Toaster from "./../../components/snackBar_toaster";
import Header from "./../../components/Header";
import { withRouter } from 'react-router-dom';
import QuestionIndex from './questionIndex'
const { width, height } = Dimensions.get('window')

const Loader = require("./../../assets/loadingGif.gif");


const TimerComponent = ({ 
  testStartRemainingTime,
  testDuration,
  submitTest, 
  activeQuestion,
  totalQuestion, onPress, navigation
}) => {
  const _activeQuestion = activeQuestion <= 1 ? `0${activeQuestion + 1}` : activeQuestion
  return (
      <View style={styles.timerComponent}>
          <View style={styles.timer}>
              {/* <Image source={clock} style={{ width: 42, height: 42 }} /> */}
               <QueryBuilderIcon
                        style={{
                          marginRight: 8,
                          color: "#F5591F",
                          width: 22,
                          height: 22,
                        }}
                        size={22}
                      />
              <View style={{ flexDirection: 'column', marginHorizontal: 10 }}>
                  <Text style={{fontSize: 12}}>Time</Text>
                  <Timer
                      timer={
                        parseInt(testStartRemainingTime, 10) / 60 ||
                        parseInt(testDuration, 10) / 60
                      }
                      onSubmit={() => typeof submitTest === 'function' ? submitTest() : null}
                      // inSeconds={testStartRemainingTime ? true : false}
                      // size={15}
                      hours={true}
                    />
              </View>
          </View>

         <QuestionIndex navigation={navigation}/>

      </View>
  )
}
// import GestureRecognizer, {swipeDirections} from './../UI-Components/gestureRecogniseComponent';
class QuizContainer extends React.Component {
  state = {
    showToast: false,
    toasterMessage: "",
  };
  onBackButtonEvent(event) {
    event.preventDefault();                        
    window.location.pathname = '/Home';
    }

  componentDidMount() {
    // const {navigation} = this.props;
    // window.onpopstate = this.onBackButtonEvent
    const { history } = this.props;
    window.addEventListener("popstate", () => {
      history.push('/Home');
    });
    const { state,  }= this.props.location || {};
        const { isTestSeries, testId, isMaterialTest=false } = state || {}
     


    if (testId) {
      this.props.getTest(testId, false, isTestSeries, isMaterialTest);
    }
    // this.props.startTest();
  }

  componentWillUnmount() {
    // window.onpopstate = () => {
    //   this.props.history
    // }
    this.props.clearTest();
    this.props.clearSubmitTestData();
  }

  shouldComponentUpdate(prevProps) {
    if (
      prevProps.testInfo &&
      !prevProps.testInfo.loading &&
      prevProps.testInfo.test
    ) {
      if (
        (prevProps.testInfo.questionsInfo &&
          prevProps.testInfo.questionsInfo.length > 0) ||
        prevProps.testInfo.selectedAnswers ||
        prevProps.testInfo.activeQuestion > 0 ||
        prevProps.testInfo.touched
      ) {
        return false;
      }
      return true;
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      if (this.props.error) {
        let text = `${this.props.errMessage || "Your test time is completed"} ${
          this.props.remainingTime || ""
        }`;
        this.showToaster(text, 1500, () => {
          this.props.history.push("/Home");
        });
      }
    }

    if (prevProps.errInfo !== this.props.errInfo) {
      if (this.props.errInfo) {
        if (this.props.errInfo === "Unauthenticated.") {
          // this.props.dispatchClearHomeInfo();
          setTimeout(() => {
            // resetAll(this.props.navigation, 'Home');
          }, 500);
        }
      }
    }
    if(prevProps.testInfo !== this.props.testInfo){
      if(this.props.testInfo){
        if(!(this.props.testInfo && this.props.testInfo.length > 0)){
          // this.props.history.push('/Home')
        }
      }
    }
    
    if (prevProps.isQuestionsUnavailable !== this.props.isQuestionsUnavailable) {
      if (this.props.isQuestionsUnavailable) {
          this.showToaster('Questions are not available, Please try again later!!', 1500, () => {
              this.props.history.push('/Home');
          });
      }
  }
  }

  submitTestIfBackPress = () => {
    // const isPlannedTest = this.props.navigation.getParam('plannedTest', false);
    // const isTestSeries = this.props.navigation.getParam('isTestSeries', false);
    const { state } = this.props.location || {};
    const { plannedTest = false, isTestSeries, isMaterialTest } = state || {};
    this.props.submitTest(plannedTest, isTestSeries, isMaterialTest);
  };

  showToaster = (msg, duration, callBack) => {
    this.setState({
      showToast: true,
      toasterMessage: msg,
    }, () => {
      if(callBack && typeof callBack === 'function') {         
        setTimeout(callBack, duration);
    }
    });
  };

  onSwipeLeft = (gestureState) => {
    // this.setState({myText: 'You swiped left!'});
  };

  onSwipeRight = (gestureState) => {

    this.setState({ myText: "You swiped right!" });
  };

  render() {
    const { loading, testInfo, testDuration, error, testStartRemainingTime,activeQuestion, totalQuestions } = this.props;
    console.log(testStartRemainingTime, "sdfllsdf")
    const config = {
     velocityThreshold: 0.3,
     directionalOffsetThreshold: 80
   };
    return (
      <>
        <Header
          title={testInfo?.title}
          // headerLeftClick={() => this.props.history.goBack()}
          // headerRightClick={() => this.props.history.push("/Home")}
          // backButton={true}
          // headerRight={true}
          // isFromQuiz={true}
        />
        {loading ? (
          <View
            style={{
              width: "100%",
              height: "90vh",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: Styles.fiveMantraBgColor,
            }}
          >
            {/* <ActivityIndicator /> */}
            <Image source={Loader} style={{ width: 250, height: 250 }} />
          </View>
        ) : null}
        {!loading && (
          <Container maxWidth="lg">
            <div className="main-component">
              {!loading &&
              !error &&
              testInfo &&
              testInfo.test &&
              testInfo.test.length ? (
                <div
                  className="exam-component"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    paddingBottom: 7,
                  }}
                  //   style={{ flex: 1, backgroundColor: '#fff',marginHorizontal:10,elevation:9,marginVertical:10,borderRadius:10,width:'95%'
                >
                    <View style={{ marginTop: 10 }}>
                          <TimerComponent
                              testStartRemainingTime={testStartRemainingTime}
                              testDuration={testDuration}
                              submitTest={this.submitTestIfBackPress}
                              activeQuestion={activeQuestion}
                              totalQuestion={totalQuestions}
                              navigation={this.props.navigation}
                          />
                      </View>

                      
                      <View style={{ flex: 1, }}>
                      <Quiz navigation={this.props.navigation} route={this.props.route} />
                  </View>
                </div>
              ) : null}

              {/* {
                        !loading && error && <Text style={{marginLeft:30, marginBottom:30,color:"#222"}}>{this.props.errInfo || this.props.errMessage|| 'something went wrong...'}</Text>
                    } */}
              {/* <Toast 
                        ref="toast" 
                        style={{backgroundColor: '#fff', 
                        color:'#222', borderRadius: 50}} 
                        textStyle={{color: '#222'}} 
                        positionValue={160}
                        position={'bottom'}
                    /> */}

              <Toaster
                show={this.state.showToast}
                message={this.state.toasterMessage}
                handleClose={() => {
                  this.setState({
                    showToast: false
                  })
                }}
              />
            </div>
          </Container>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.testInfo && state.testInfo.loading,
  testInfo: state.testInfo && state.testInfo,
  testDuration:
    state.testInfo &&
    state.testInfo.testDuration &&
    state.testInfo.testDuration,
  testStartRemainingTime:
    state.testInfo &&
    state.testInfo.totalResponse &&
    state.testInfo.totalResponse.status &&
    state.testInfo.totalResponse.status.time_remaining,
  error: state.testInfo && state.testInfo.error,
  errInfo:
    state.testInfo &&
    state.testInfo.errorInfo &&
    state.testInfo.errorInfo.response,
  errMessage:
    state.testInfo &&
    state.testInfo.errorInfo &&
    state.testInfo.errorInfo.response &&
    state.testInfo.errorInfo.response.data &&
    state.testInfo.errorInfo.response.data.message,
  remainingTime:
    state.testInfo &&
    state.testInfo.errorInfo &&
    state.testInfo.errorInfo.response &&
    state.testInfo.errorInfo.response.data &&
    state.testInfo.errorInfo.response.data["time Remaining"],
    activeQuestion: state.testInfo && state.testInfo.activeQuestion,
    totalQuestions: state.testInfo && state.testInfo.test?.length,
    questionsInfo: state.testInfo && state.testInfo.questionsInfo && state.testInfo.questionsInfo || [],
    isQuestionsUnavailable: state?.testInfo?.test?.length === 0,
});

const styles = StyleSheet.create({
  flexRowBetween: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexDirection: 'row',
    // backgroundColor: '#fff',
    fontSize:12,
    marginTop:10,
    paddingHorizontal:10
  },
  main: {
    flex: 1,
    backgroundColor: Styles.fiveMantraBgColor
},
header: {
    fontSize: 20,
    fontWeight: '700',
    color: '#000'
},
timerComponent: {
    flexDirection: 'row',
    paddingHorizontal: 12,
    // paddingVertical: 16,
    height: 65,
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 8,
    marginBottom: 12,
    borderWidth: 3,
    marginHorizontal: 15,
    borderColor: '#fff',
    overflow:'hidden'    
},
timer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 10,
},
questionIndex: {
    width: (width / 2 - 21),
    height: '100%',
    backgroundColor: '#ffdb4d',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'flex-end',
    borderTopStartRadius: 50,
    borderLeftWidth: 3,
    borderLeftColor: '#fff'
},
questionNo: {
    marginHorizontal: 15,
    borderBottomColor: 'rgba(0,0,0,0.6)',
    borderBottomWidth: 0.6,
    marginTop: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
    marginBottom: 10,
},
flexRow: {
    // flex:1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12
},
});

export default connect(mapStateToProps, {
  getTest,
  // dispatchClearHomeInfo,
  clearTest,
  clearSubmitTestData,
  submitTest,
})(withRouter(QuizContainer));
